export default function QuizQuestion({ pergunta, numero, total, resposta, onChange }) {
  const letras = Object.keys(pergunta.opcoes);

  return (
    <div className="quiz-question">
      <div className="quiz-progress">
        <div className="quiz-progress-bar" style={{ width: `${(numero / total) * 100}%` }} />
      </div>

      <p className="quiz-step-label">{numero} de {total}</p>
      <h2 className="quiz-question-text">{pergunta.texto}</h2>

      <div className="quiz-options">
        {letras.map((letra) => (
          <button
            key={letra}
            className={`quiz-option-btn ${resposta === letra ? 'selected' : ''}`}
            onClick={() => onChange(letra)}
            type="button"
          >
            <span className="quiz-option-letra">{letra}</span>
            <span className="quiz-option-texto">{pergunta.opcoes[letra]}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
